import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"back-btn",on:{"click":function($event){_vm.routePath ? _vm.$router.push(_vm.routePath) : _vm.$router.back()}}},[_c(VIcon,{staticClass:"icon"},[_vm._v("mdi-arrow-left")]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }